import React from 'react'
import {
  AccessRestricted,
  ShowPageContainer,
} from 'src/components/PageLayout/ShowPage'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { ServicesProvider } from '../context/ServicesContext'
import { ServicesShowPageHeader } from './ServicesShowPageHeader'
import { ServicesShowPageContent } from './ServicesShowPageContent'

const ServicesShowPageInner = (): JSX.Element => {
  const canViewServices = useCanPerformAction(CAPABILITY.CAN_VIEW_SERVICES)

  if (!canViewServices) {
    return (
      <ShowPageContainer data-testid="show-page-access-restricted">
        <AccessRestricted />
      </ShowPageContainer>
    )
  }

  return (
    <ShowPageContainer>
      <ServicesShowPageHeader />
      <ServicesShowPageContent />
    </ShowPageContainer>
  )
}

export const ServicesShowPage = (): JSX.Element => (
  <ServicesProvider>
    <ServicesShowPageInner />
  </ServicesProvider>
)
